import Accordeon from './Accordeon'

export default Accordeon
